import { render, staticRenderFns } from "./extra-ich-habe-eine-idee.vue?vue&type=template&id=d2c00b74&lang=pug&"
import script from "./extra-ich-habe-eine-idee.vue?vue&type=script&lang=js&"
export * from "./extra-ich-habe-eine-idee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports